module.exports = __webpack_public_path__ + "img/form4.c25b779e.jpg";